import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializePushNotifications } from './utils/pushNotifications';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);

        // Initialize push notifications after service worker is ready
        setTimeout(() => {
          initializePushNotifications();
        }, 1000);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
        // Fallback: initialize push notifications without service worker
        setTimeout(() => {
          initializePushNotifications();
        }, 1000);
      });
  });
} else {
  // Fallback for browsers without service worker support
  setTimeout(() => {
    initializePushNotifications();
  }, 1000);
}